import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

const PaymentsAndAccounts = (props: { systemFormPayload: UseFormPayload }) => {
  const { systemFormPayload } = props

  const {
    entityState: {
      accounts_email,
      accounts_phone,
      bank_account_bsb,
      bank_account_name,
      bank_account_number,
      business_number,
    },
    handlers,
  } = systemFormPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column', padding: 'large' }}
      title="Payments &amp; Accounts"
    >
      <Form.Row>
        <Form.Field label="Accounts Email">
          <input name="accounts_email" type="email" value={accounts_email} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Accounts Phone" marginTop={['large', 0]}>
          <input name="accounts_phone" value={accounts_phone} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="Bank Account Name">
          <input name="bank_account_name" value={bank_account_name} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Business Number" marginTop={['large', 0]}>
          <input name="business_number" value={business_number} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="BSB">
          <input name="bank_account_bsb" value={bank_account_bsb} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Account Number" marginTop={['large', 0]}>
          <input name="bank_account_number" value={bank_account_number} {...handlers} />
        </Form.Field>
      </Form.Row>
    </DashboardModule>
  )
}

export default PaymentsAndAccounts
